<script setup lang="ts">
import ActionButton from '@/components/Elements/Buttons/ActionButton.vue'
import Alert from '@/components/Elements/Alerts/Alert.vue'
import TutorialFrame from '@/components/Interface/Modal/Modals/Tutorial/TutorialFrame.vue'
import { computed } from 'vue'
import { useRoute } from 'vue-router'
import { handleNext } from '../tutorialSteps'
import { useSpyStore } from '@/stores/spyStore'

const route = useRoute()
const spyStore = useSpyStore()

const handleNextStep = async () => {
  await handleNext('tutorial_spy_assign_task')
}

const isOnSpiesSection = computed(() => {
  return route.path.startsWith('/diplomacy/spies')
})

const hasSpies = computed(() => {
  return spyStore.spies.size > 0
})
</script>

<template>
  <TutorialFrame 
    video-url="https://cdn.ferion.com/videos/advisors/temperate/spy.webm"
  >
    <template #text>
      <p class="pb-2">
        Lets put your spy at work!
      </p>
      <p class="pb-2">
        Your spies can work on various missions, some missions require more advanced spies. So pick a mission that matches the level the spy has.
      </p>
      <p class="pb-2">
        The default mission is counter espionage, where your spy will try to catch enemy spies.
      </p>
      <p class="pb-2">
        I suggest we train our spy further, so we can do more interesting missions in the future.
      </p>
    </template>

    <template #alerts>
      <Alert type="info">
        Click on your spy and assign a mission.
      </Alert>
    </template>

    <template #buttons>
      <ActionButton @click="handleNextStep">
        Continue
      </ActionButton>
    </template>
  </TutorialFrame>
</template>

<style scoped lang="scss">

</style>